import type { PropsWithChildren } from 'react';

import { Box } from '@myphx-engineering/phx-design-system';

import classes from './shopping-header.module.css';

export const ShoppingHeader = (props: PropsWithChildren) => {
    const { children } = props;
    return (
        <Box className={classes['shopping-header']}>
            {children}
            {/* oxlint-disable-next-line jsx-a11y/alt-text -- tracked in docs/oxlint-violations.md */}
            <img
                src="/static/img/myphx-pattern.svg"
                height="120"
                aria-hidden="true"
                width="120"
            />
        </Box>
    );
};
